import React, { Component } from 'react'
import { Link } from 'gatsby'

import './style.scss'

class SiteSwitcher extends Component {
  render() {
    const slug = this.props.slug
    const site = this.props.site
    const exclusive = this.props.exclusive

    let switchSite = function(site) {
      if (site === 'mt') {
        return 'wt'
      } else {
        return 'mt'
      }
    }

    let switchSiteString = function(site) {
      if (site === 'mt') {
        return 'Wilmington'
      } else {
        return 'M&T'
      }
    }
    return (
      <Link
        className={'site-switcher ' + (exclusive && 'disabled')}
        to={'/' + switchSite(site) + '/' + slug}
      >
        Switch to {switchSiteString(site)}
      </Link>
    )
  }
}

export default SiteSwitcher
